// extracted by mini-css-extract-plugin
export var btn = "CineHero-module--btn--9d328";
export var emailInfo = "CineHero-module--emailInfo--152eb";
export var film = "CineHero-module--film--34f9c";
export var form = "CineHero-module--form--7d369";
export var innerWrapper = "CineHero-module--innerWrapper--c9a69";
export var intro = "CineHero-module--intro--6db47";
export var note = "CineHero-module--note--5ace3";
export var personalInfo = "CineHero-module--personalInfo--2db1c";
export var submitSection = "CineHero-module--submitSection--dae76";
export var validation = "CineHero-module--validation--cb2ef";
export var wrapper = "CineHero-module--wrapper--1f289";